import React from "react";
import { markdown } from "markdown";

export default ({ icon, colour, textContent: { textContent }, heading }) => (
  <div className="col-md-4 text-center">
    <div className={`services color-${colour}`}>
      <span className="icon">
        <i className={`icon-${icon}`} />
      </span>
      <div className="desc">
        <h3>{heading}</h3>
        <div
          dangerouslySetInnerHTML={{ __html: markdown.toHTML(textContent) }}
        />
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/skillTile.js